import React, { Component, Fragment } from "react";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import Footer from "../partials/Footer";
import WalletBox from "../partials/WalletBox";
import { BrowserRouter as Router, Route, Switch, Redirect, withRouter } from "react-router-dom";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons/faList";
import ReactDatatable from '@ashvin27/react-datatable';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import { addDepositCash } from "../../actions/contestActions";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { } from "react-router-dom";
import { toast, Toaster } from 'react-hot-toast';
import $ from 'jquery';
import classnames from "classnames";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import SidebarWallet from "./SidebarWallet";
import Moment from 'moment';
import * as myConstList from '../../BaseUrl';

import { CopyToClipboard } from 'react-copy-to-clipboard';
import Card from "react-bootstrap/Card";
import { loadStripe } from "@stripe/stripe-js";
import Loading from "../layout/Loading";
const configToken = {
  headers: {
    Authorization: 'Bearer ' + `${localStorage.getItem("jwtToken")}`,
  },
};
const baseUrl = myConstList.baseUrl;
const publicStripeKey = myConstList.stripePublicKey;
const toastStyles = {
  style: {
    borderRadius: '10px',
    background: '#fff',
    color: '#000',
  },
  errors: {},
}
class PaymentSuccess extends Component {

  constructor(props) {
    super(props);
    this.state = {
      urltemp:""
    };
  }
  componentDidMount() {
    var urlTempParam = "";
    if (
      localStorage.getItem("source") !== "" &&
      localStorage.getItem("theme") !== ""
    ) {
      urlTempParam =
        "?source=" +
        localStorage.getItem("source") +
        "&theme=" +
        localStorage.getItem("theme");
      // console.log("urlStamp==",urltemp);
      this.setState({ urltemp: urlTempParam, themeSet: localStorage.getItem("theme") });
    }

    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get('session_id');
    var newData = { "sessionId": sessionId};
    axios.post(baseUrl + "api/add-cash-deposit-stripe", newData, configToken).then(res => {
      // console.log("res.datares.datares.data==",res.data);
      if (res.data.success) {
        // toast.success(res.data.message, toastStyles);
      } else {
          window.location.href = "/addCash" + urlTempParam;
        toast.error("error", toastStyles);
      }
      // setTimeout(() => {
      //   window.location.href = "/addCash" + this.state.urltemp;
      // }, 1500);
      // this.setState({ cashWalletRecords: res.data.data })
    })
    .catch();
  };


  render() {
    const { errors1, loadingProcess } = this.state;
    if (loadingProcess) {
      return <Loading themeSet={this.state.themeSet} />;
    }
    return (
      <>
        <Navbar urlPath={true} symbol={false} />
        <Sidebar />
        <div className="container container2">
          <div className=" padding_d in_page">
            {/*  */}
            <div className="row" >
              <div className="col-md-12 mb-3" >
                <div className="wallet_box text-center status-main">
                  <div className="status-img">
                    <img src={"../img/success2.gif"} alt="barcode" className="barcode_img img-fluid" />
                  </div>
                  <div className="status-content">
                    <h3 className="text-success m-0">Your Payment is Successfull</h3>
                    <p><b>Thank you for your payment. An automated payment receipt will be sent to your registered email.</b></p>
                    <a className="btn btn_man m-auto pl-5 pr-5" href={"/addCash" + this.state.urltemp}>Home</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <Footer />
        <Toaster position="bottom-right" reverseOrder={false} />
      </>
    );
  }

}

PaymentSuccess.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  addDepositCash: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors,
  contestdata: state.contestdata,
});

export default connect(
  mapStateToProps,
  { addDepositCash },
)(withRouter(PaymentSuccess));

